module.exports = __webpack_public_path__ + "img/ruanbao2.ff154758.jpg";